export default {"src":"/_next/static/media/bank-mastercard.9e1d856d.svg","height":24,"width":40,"blurWidth":0,"blurHeight":0};